import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const deleteApplicantAutomation = (
  applicantTriggeredCommunicationId: number,
  deleteFollowUps?: boolean,
) =>
  createGenericDispatcher({
    name: 'DELETE_APPLICANT_AUTOMATION',
    loadFunction: () =>
      Api.del(
        `/applicant-automations/${applicantTriggeredCommunicationId}?deleteFollowUps=${!!deleteFollowUps}`,
      ),
    args: { applicantTriggeredCommunicationId },
  });
